import { AllEmployees as AllEmployeesComponent } from "../../Components";

const AllEmployees = () => {
  return <AllEmployeesComponent />;
};

export default AllEmployees;
